export default "__VITE_ASSET__CHVXuc4O__"